(function () {
  const callouts = document.querySelectorAll('.getout-products');
  if (!callouts.length) return;

  const theme = window.getoutTheme || {};
  const cardStyle = 'card';
  const cardScheme = 'scheme-225e243e-f00e-4a80-9133-615bb7a0fc34';

  function formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return 'NZ$' + dollars;
  }

  async function fetchProduct(handle) {
    try {
      const res = await fetch('/products/' + handle.trim() + '.js');
      if (!res.ok) return null;
      return res.json();
    } catch (e) { return null; }
  }

  async function fetchCollection(handle, limit) {
    try {
      const res = await fetch('/collections/' + handle.trim() + '/products.json?limit=' + limit);
      if (!res.ok) return [];
      const data = await res.json();
      const products = data.products || [];
      // /collections/*/products.json returns prices as dollar strings ("59.99"),
      // while /products/*.js returns integer cents (5999). formatMoney expects cents,
      // so normalise the collection path to cents to avoid a /100 price bug.
      products.forEach(function (p) {
        (p.variants || []).forEach(function (v) {
          v.price = Math.round(parseFloat(v.price) * 100);
          v.compare_at_price = (v.compare_at_price != null && v.compare_at_price !== '')
            ? Math.round(parseFloat(v.compare_at_price) * 100)
            : null;
        });
      });
      return products;
    } catch (e) { return []; }
  }

  function renderPrice(variant) {
    const price = formatMoney(variant.price);
    const compare = variant.compare_at_price && variant.compare_at_price > variant.price
      ? formatMoney(variant.compare_at_price)
      : null;

    if (compare) {
      return '<div class="price price--on-sale">'
        + '<div class="price__container">'
        + '<div class="price__sale">'
        + '<span class="visually-hidden">Sale price</span>'
        + '<span class="price-item price-item--sale price-item--last">' + price + '</span>'
        + '<span class="visually-hidden">Regular price</span>'
        + '<s class="price-item price-item--regular">' + compare + '</s>'
        + '</div>'
        + '</div>'
        + '</div>';
    }
    return '<div class="price">'
      + '<div class="price__container">'
      + '<div class="price__regular">'
      + '<span class="price-item price-item--regular">' + price + '</span>'
      + '</div>'
      + '</div>'
      + '</div>';
  }

  function renderCard(product) {
    const variant = product.variants && product.variants[0];
    const rawImage = product.images && product.images[0];
    const imageSrc = rawImage
      ? (typeof rawImage === 'string' ? rawImage : rawImage.src)
      : null;
    const image = imageSrc
      ? imageSrc.replace(/(\.[a-z]+)(\?|$)/, '_533x$1$2')
      : null;
    const url = '/products/' + product.handle;
    const title = product.title;
    const vendor = product.vendor;
    const isCard = cardStyle === 'card';

    const cardClasses = [
      'card',
      'card--' + cardStyle,
      image ? 'card--media' : 'card--text',
      isCard ? 'color-' + cardScheme + ' gradient' : '',
      'card--extend-height'
    ].filter(Boolean).join(' ');

    const innerClasses = [
      'card__inner',
      !isCard ? 'color-' + cardScheme + ' gradient' : '',
      (image || !isCard) ? 'ratio' : ''
    ].filter(Boolean).join(' ');

    return '<div class="card-wrapper product-card-wrapper underline-links-hover">'
      + '<div class="' + cardClasses + '" style="--ratio-percent: 100%;">'
      + '<div class="' + innerClasses + '" style="--ratio-percent: 100%;">'
      + (image
        ? '<div class="card__media"><div class="media media--transparent media--hover-effect">'
          + '<img src="' + image + '" alt="' + title.replace(/"/g, '&quot;') + '" loading="lazy" width="533" height="533">'
          + '</div></div>'
        : '')
      + '<div class="card__content">'
      + '<div class="card__information">'
      + '<h3 class="card__heading"><a href="' + url + '" class="full-unstyled-link">' + title + '</a></h3>'
      + '</div>'
      + '</div>'
      + '</div>'
      + '<div class="card__content">'
      + '<div class="card__information">'
      + '<h3 class="card__heading h5"><a href="' + url + '" class="full-unstyled-link">' + title + '</a></h3>'
      + '<div class="card-information">'
      + '<div class="caption-with-letter-spacing light">' + vendor + '</div>'
      + (variant ? renderPrice(variant) : '')
      + '</div>'
      + '</div>'
      + '</div>'
      + '</div>'
      + '</div>';
  }

  async function hydrateCallout(el) {
    const handlesAttr = el.dataset.handles;
    const collectionAttr = el.dataset.collection;
    const heading = el.dataset.heading || 'Gear at Get Out';
    const limit = Math.min(parseInt(el.dataset.limit || '4', 10), 6);

    let products = [];

    if (handlesAttr) {
      const handles = handlesAttr.split(',').filter(Boolean);
      const results = await Promise.all(handles.map(fetchProduct));
      products = results.filter(Boolean);
    } else if (collectionAttr) {
      products = await fetchCollection(collectionAttr, limit);
    }

    if (!products.length) {
      el.style.display = 'none';
      return;
    }

    const count = Math.min(products.length, limit);

    el.innerHTML = '<div class="getout-callout">'
      + '<p class="getout-callout__heading">' + heading + '</p>'
      + '<ul class="getout-callout__grid getout-callout__grid--' + Math.min(count, 4) + ' list-unstyled" role="list">'
      + products.slice(0, limit).map(function (p) {
          return '<li>' + renderCard(p) + '</li>';
        }).join('')
      + '</ul>'
      + '</div>';
  }

  callouts.forEach(hydrateCallout);
})();
